export default __webpack_public_path__ + "static/media/logo_bbva.76d19e3a.svg";